<script setup lang="ts">
  const { document, i18nParams } = await useDocument();

  useHead({
    title: document.value?.title
  });

  const setI18nParams = useSetI18nParams();
  setI18nParams(i18nParams.value);
</script>

<template>
  <main>
    <DocumentSection
      v-if="document"
      :document="document" />
  </main>
</template>
